import { render, staticRenderFns } from "./ModalAddRekening.vue?vue&type=template&id=46cc66bf"
import script from "./ModalAddRekening.vue?vue&type=script&lang=js"
export * from "./ModalAddRekening.vue?vue&type=script&lang=js"
import style0 from "./ModalAddRekening.vue?vue&type=style&index=0&id=46cc66bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports